import React, { FunctionComponent } from "react";
import { Icon } from "@bca/ui-library";
import styled from "styled-components";

import { LinkButton } from "@bca/ui-library";
import useDeviceType from "../../hooks/useDeviceType.hook";

interface NavigationButtonProps {
  isButtonDisabled: boolean;
}

const NavigationButton = styled(LinkButton)<NavigationButtonProps>`
  text-transform: capitalize;
  min-width: 40px;
  ${({ isButtonDisabled }) =>
    isButtonDisabled &&
    `
    cursor: default;
    opacity: 0.4;
    pointer-events: none;
    `};
`;

interface LotNavigationButtonProps {
  nextVrm?: string;
  prevVrm?: string;
  direction: "previous" | "next";
  index?: number;
  totalCount?: number;
}

const LotNavigationButton: FunctionComponent<LotNavigationButtonProps> = ({
  direction,
  nextVrm,
  prevVrm,
  index,
  totalCount,
}) => {
  const { isMobileDevice } = useDeviceType();

  const getNavigationLink = (url: string | null) => {
    const formattedUrl = url?.replace("&bq=IsProvisional%3Atrue", "");
    return formattedUrl?.replace("&requestOrigin=VendorPortal", "");
  };

  const isFirstLot = index === 1;
  const isLastLot = index === totalCount;

  return (
    <>
      {direction === "previous" ? (
        <NavigationButton
          variant="button"
          px={3}
          my={1}
          height="42px"
          fontSize={1}
          isButtonDisabled={isFirstLot}
          link={getNavigationLink(prevVrm)}
          shouldOpenInNewWindow={false}
          data-testid="previous-lot-navigation-button"
        >
          <Icon
            name="chevron-left"
            height={14}
            width={14}
            weight="solid"
            mr={isMobileDevice ? 0 : 2}
            data-testid="icon-container-chevron-left"
          ></Icon>
          {!isMobileDevice && direction}
        </NavigationButton>
      ) : (
        <NavigationButton
          variant="button"
          px={3}
          my={1}
          height="42px"
          fontSize={1}
          isButtonDisabled={isLastLot}
          link={getNavigationLink(nextVrm)}
          shouldOpenInNewWindow={false}
          data-testid="next-lot-navigation-button"
        >
          {!isMobileDevice && direction}
          <Icon
            name="chevron-right"
            height={14}
            width={14}
            weight="solid"
            mr={isMobileDevice ? 0 : 2}
            data-testid="icon-container-chevron-right"
          ></Icon>
        </NavigationButton>
      )}
    </>
  );
};

export default LotNavigationButton;
